import { Box, Button, CircularProgress } from "@mui/material";
import { purple, purpleLight } from "../../../../theme/colors";

interface StepFormActionsProps {
  showBack: boolean;
  onBack: () => void;
  backLabel?: string;
  disabled?: boolean;
  loading?: boolean;
  loadingLabel?: string;
  submitLabel: string;
  type?: "submit" | "button";
  onSubmitClick?: () => void;
}

export default function StepFormActions({
  showBack,
  onBack,
  backLabel = "Back",
  disabled = false,
  loading = false,
  loadingLabel,
  submitLabel,
  type = "submit",
  onSubmitClick,
}: StepFormActionsProps) {
  return (
    <Box display="flex" justifyContent="flex-end" gap={1.5} mt={4}>
      {showBack && (
        <Button
          variant="outlined"
          onClick={onBack}
          disabled={loading}
          sx={{
            minWidth: 130,
            borderColor: purple,
            color: purple,
            borderRadius: 2,
            textTransform: "none",
            fontWeight: 600,
            "&:hover": { borderColor: purple, bgcolor: purpleLight },
          }}
        >
          {backLabel}
        </Button>
      )}
      <Button
        disabled={disabled || loading}
        variant="contained"
        disableElevation
        type={type}
        onClick={onSubmitClick}
        startIcon={loading ? <CircularProgress size={16} sx={{ color: "#fff" }} /> : undefined}
        sx={{
          minWidth: 160,
          bgcolor: purple,
          borderRadius: 2,
          textTransform: "none",
          fontWeight: 600,
          "&:hover": { bgcolor: "#7A2074" },
          "&.Mui-disabled": {
            bgcolor: loading ? purple : undefined,
            color: loading ? "#fff" : undefined,
            opacity: loading ? 0.85 : undefined,
          },
        }}
      >
        {loading ? loadingLabel || submitLabel : submitLabel}
      </Button>
    </Box>
  );
}
